module.exports = __webpack_public_path__ + "static/media/logoText.3f07d8c6.png";